"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
require("./checkbox.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
} // Ant Design components:
// Custom Turing CSS styles
// Checkbox component
function Checkbox(props) {
  // Defining variables ---
  var disabled = props.disabled ? true : false,
    checked = props.indeterminate ? true : props.checked ? true : false,
    group = false,
    indeterminate = props.indeterminate ? {
      indeterminate: true
    } : {},
    underIndeterminate = false,
    list = false,
    label = props.children || props.label,
    name = '',
    cbxID = '',
    options = [],
    checkedOptions = [],
    cssClassList = [],
    style = {},
    id = '';

  // --- end of Defining variables

  // Assigning values ---

  // default values

  //cssClassList.push('');

  // prop values

  if (props.group) {
    group = props.group;
  }
  if (props.underIndeterminate) {
    underIndeterminate = true;
    cssClassList.push('group-indeterminate');
  }
  if (props.list) {
    list = true;
    cssClassList.push('cbx-list-group');
  }
  if (props.name) {
    name = props.name;
  }
  if (props.id) {
    cbxID = props.id;
  }
  if (props.className) cssClassList.push(props.className);
  if (props.classList) cssClassList.push(props.classList);
  if (props.options) {
    options = props.options;
  }
  if (props.checkedOptions) {
    checkedOptions = props.checkedOptions;
  }
  if (props.disabled) {
    disabled = true;
  }
  if (props.checked) {
    checked = true;
  }
  if (props.style) style = props.style;

  // Joining classes to string
  cssClassList = cssClassList.join(' ');

  // --- end of Assigning values

  // Passing handlers to component
  var handlers = {};
  for (var prop in props) {
    if (typeof props[prop] === "function") Object.assign(handlers, _defineProperty({}, prop, props[prop]));
  }

  // Building component strucutre

  return buildComponent(label, style, group, indeterminate, underIndeterminate, cbxID, name, options, checkedOptions, disabled, checked, cssClassList, handlers);
}

/* Build compnent strucure - function */

function buildComponent(label, style, group, indeterminate, underIndeterminate, cbxID, name, options, checkedOptions, disabled, checked, cssClassList, handlers) {
  if (group === true) {
    if (underIndeterminate === true) {
      return group = /*#__PURE__*/_react["default"].createElement(_antd.Checkbox.Group, _extends({
        id: cbxID,
        style: style,
        className: cssClassList,
        name: name,
        options: options,
        value: checkedOptions
      }, handlers));
    } else {
      return group = /*#__PURE__*/_react["default"].createElement(_antd.Checkbox.Group, _extends({
        id: cbxID,
        style: style,
        className: cssClassList,
        name: name,
        options: options,
        defaultValue: checkedOptions
      }, indeterminate, handlers));
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_antd.Checkbox, _extends({
    id: cbxID,
    style: style,
    className: cssClassList,
    name: name,
    defaultChecked: checked,
    checked: checked,
    disabled: disabled
  }, indeterminate, handlers), label);
}
var _default = exports["default"] = Checkbox;